import Refresher from './Refresher';

export default {
  install(Vue) {
    Vue.use(Refresher);
  },
};
